import { render, staticRenderFns } from "./versionList.vue?vue&type=template&id=f62ee11a&scoped=true&"
import script from "./versionList.vue?vue&type=script&lang=js&"
export * from "./versionList.vue?vue&type=script&lang=js&"
import style0 from "./versionList.vue?vue&type=style&index=0&id=f62ee11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62ee11a",
  null
  
)

export default component.exports